import React from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import Chevron from '../Chevron'
import styled from 'styled-components'

const Img = styled.img`
  width: 100%;
  height: auto;
`

const Carousel = ({images, square, mBottom}) => {
    const imgs = images;
    return (
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={square ? 100 : 60}
        totalSlides={imgs.length}
        style={{ padding: square ? '0px' : '30px', position: 'relative', marginBottom: mBottom }}
      >
        <Slider>
          {(
            imgs.map( (image, ind) => {
              return (<Slide index={ind}><Img src={image} alt="Carousel image" /></Slide>)
            })
          )}
        </Slider>
        <ButtonBack style={{ position: 'absolute', left: '40px', top: 'calc(50% - 10px', transform: 'rotate(180deg)' }}><Chevron width={20} fill={"#FFF"} /></ButtonBack>
        <ButtonNext style={{ position: 'absolute', right: '40px', top: 'calc(50% - 10px' }}><Chevron width={20} fill={"#FFF"} /></ButtonNext>
      </CarouselProvider>
    );
}

export default Carousel